import { render, staticRenderFns } from "./ProjectCardFollow.vue?vue&type=template&id=3f3da0da"
import script from "./ProjectCardFollow.vue?vue&type=script&lang=js"
export * from "./ProjectCardFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports